/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 */
/* eslint-disable */
export function getDateTime(date, is12Hours, locales = "en-GB", onlyHours = false) {
  if (is12Hours) {
    if (onlyHours) {
      return new Intl.DateTimeFormat(locales, {
        timeZone: "UTC",
        hour12: false,
        // hour: "2-digit",
        // minute: "2-digit",
        // second: "2-digit",
      }).format(date);
    }
    return new Intl.DateTimeFormat(locales, {
      timeZone: "UTC",
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      // hour: "2-digit",
      // minute: "2-digit",
      // second: "2-digit",
    }).format(date);
  }
  return new Date(date).toLocaleString("en-GB");
}

export function getDateTime2(value) {
  const date = new Date(value);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const formattedDate = `${
    months[date.getMonth()]
  } ${date.getDate()} ${date.getFullYear()} at ${date.getHours()}:${
    date.getMinutes() < 10 ? "0" : ""
  }${date.getMinutes()}`;

  return formattedDate;
}

export function getDateTime3(value) {
  const date = new Date(value);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const formattedDate = `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;

  return formattedDate;
}

/** Returns true is a string is plus code e.g. 8FWH4HVG+3V 8FWH4HVG+ 8FWH4H+ */
export function isPlusCode(plusCode: string): boolean {
  if (!plusCode) {
    return false;
  }
  const upperCasedPlusCode = plusCode.toUpperCase(); // needed only lowercased index
  return /(^|\s)([23456789C][23456789CFGHJMPQRV][23456789CFGHJMPQRVWX]{6}\+[23456789CFGHJMPQRVWX]{2,3})(\s|$)/.test(
    upperCasedPlusCode
  );
}

export function parseLatLon(latLongInput: string): { lat: number, lon: number } | false {
  const cleanedInput = latLongInput.replace(/\s+/g, ""); // cleaning spaces
  if (
    !/^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/.test(
      cleanedInput
    )
  ) {
    return false;
  }
  const latLongArray = cleanedInput.split(",");
  const lat = parseFloat(latLongArray[0]);
  const lon = parseFloat(latLongArray[1]);
  // eslint-disable-next-line no-restricted-globals
  if (!isNaN(lat) && !isNaN(lon)) {
    return {
      lat,
      lon,
    };
  }
  return false;
}

/**
 * Merge two objects but only existing properties
 * @method
 * @param Object obj1 - Enumerable properties
 * @param Object obj2 - Object
 * @returns Object
 */
export function mergeKeepShape(obj1, obj2) {
  Object.keys(obj2).forEach((key) => {
    if (key in obj1) {
      // or obj1.hasOwnProperty(key)
      obj1[key] = obj2[key];
    }
  });
  return obj1;
}

export function traverse(objArr, func) {
  objArr.forEach((obj) => {
    Object.keys(obj).map((objKey) => {
      func.apply(this, [obj, objKey]);
      if (objKey === "subPages" && typeof Array.isArray(obj[objKey])) {
        traverse(obj[objKey], func);
      }
      return true;
    });
  });
}

export function immutablySwapItems(items, firstIndex, secondIndex) {
  const results = items.slice();
  const firstItem = items[firstIndex];
  results[firstIndex] = items[secondIndex];
  results[secondIndex] = firstItem;
  return results;
}

export function hasURLProtocol(url: string) {
  return (
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("file://") ||
    url.startsWith("data:")
  );
}

export function arrayBufferToDataURL(arrayBuffer, mime) {
  const blob = new Blob([arrayBuffer], { type: mime });
  // eslint-disable-next-line compat/compat
  const url = window.URL || window.webkitURL;
  return url.createObjectURL(blob);
}

export function blobToBase64(blob, callback) {
  const reader = new FileReader();
  reader.onload = () => {
    const dataUrl = reader.result;
    const base64 = dataUrl.split(",")[1];
    callback(base64);
    return true;
  };
  return reader.readAsDataURL(blob);
}

/**
 * Convert Blob, Buffer to Text
 */
export function ab2str(buf) {
  return String.fromCharCode.apply(null, new Uint16Array(buf));
}

export function str2ab(str) {
  const buf = new ArrayBuffer(str.length * 2); // 2 bytes for each char
  const bufView = new Uint16Array(buf);
  // eslint-disable-next-line no-plusplus
  for (let i = 0, strLen = str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}

/**
 * Convert 64bit url string to Blob
 * @name b64toBlob
 * @method
 * @param {string} b64Data - the 64bit url string which should be converted to Blob
 * @param {string} contentType - content type of blob
 * @param {int} sliceSize - optional size of slices if omited 512 is used as default
 * @returns {Blob}
 */
export function b64toBlob(b64Data, contentType, sliceSize) {
  contentType = contentType || "";
  sliceSize = sliceSize || 512;

  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i += 1) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, { type: contentType });
}

export function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function isVisibleOnScreen(element) {
  const rectangle = element.getBoundingClientRect();
  return (
    rectangle.top >= 0 &&
    rectangle.left >= 0 &&
    rectangle.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rectangle.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

export function getURLParameter(variable: string) {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return false;
}

export function dataURLtoBlob(dataURI) {
  const arr = dataURI.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const arrBuff = base64ToArrayBuffer(arr[1]);
  return new window.Blob([arrBuff], { type: mime });
}

export function base64ToArrayBuffer(base64) {
  const bstr = window.atob(base64);
  const bytes = new Uint8Array(bstr.length);
  for (let i = 0; i < bstr.length; i += 1) {
    bytes[i] = bstr.charCodeAt(i);
  }
  return bytes.buffer;
}

export function arrayBufferToBuffer(content) {
  // eslint-disable-next-line no-buffer-constructor,no-shadow
  const buffer = new Buffer(content.byteLength);
  const view = new Uint8Array(content);
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < buffer.length; ++i) {
    buffer[i] = view[i];
  }
  return buffer;
}

export function getBase64Image(imgURL: string) {
  const canvas = document.createElement("canvas");
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.src = imgURL;
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);
  return canvas.toDataURL("image/png");
}

// export function formatFileSize(sizeInBytes): string {
//   const kilobyte = 1024;
//   const megabyte = kilobyte * kilobyte;
//   const gigabyte = megabyte * kilobyte;
//   const terabyte = gigabyte * kilobyte;
//   const precision = 2;

//   if (sizeInBytes >= 0 && sizeInBytes < kilobyte) {
//     return sizeInBytes + " B";
//   }
//   if (sizeInBytes >= kilobyte && sizeInBytes < megabyte) {
//     return (sizeInBytes / kilobyte).toFixed(precision) + " KB";
//   }
//   if (sizeInBytes >= megabyte && sizeInBytes < gigabyte) {
//     return (sizeInBytes / megabyte).toFixed(precision) + " MB";
//   }
//   if (sizeInBytes >= gigabyte && sizeInBytes < terabyte) {
//     return (sizeInBytes / gigabyte).toFixed(precision) + " GB";
//   }
//   if (sizeInBytes >= terabyte) {
//     return (sizeInBytes / terabyte).toFixed(precision) + " TB";
//   }
//   // return sizeInBytes + ' B';
// }

export function formatFileSize2(sizeInBytes, siSystem): string {
  const threshold = siSystem ? 1000 : 1024;
  if (!sizeInBytes) {
    return "";
  }
  if (sizeInBytes < threshold) {
    return sizeInBytes + " B";
  }
  const units = siSystem
    ? ["kB", "MB", "GB", "TB", "PB", "EB"]
    : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB"];
  let cUnit = -1;
  do {
    sizeInBytes /= threshold;
    cUnit += 1;
  } while (sizeInBytes >= threshold);
  return sizeInBytes.toFixed(1) + " " + units[cUnit];
}

export function formatDateTime(date, includeTime: boolean) {
  if (date === undefined || date === "") {
    return "";
  }
  const d = new Date(date);
  let cDate = d.getDate();
  cDate += "";
  if (cDate.length === 1) {
    cDate = "0" + cDate;
  }
  let cMonth = d.getMonth() + 1;
  cMonth += "";
  if (cMonth.length === 1) {
    cMonth = "0" + cMonth;
  }
  const cYear = d.getFullYear();
  let cHour = d.getHours();
  cHour += "";
  if (cHour.length === 1) {
    cHour = "0" + cHour;
  }
  let cMinute = d.getMinutes();
  cMinute += "";
  if (cMinute.length === 1) {
    cMinute = "0" + cMinute;
  }
  let cSecond = d.getSeconds();
  cSecond += "";
  if (cSecond.length === 1) {
    cSecond = "0" + cSecond;
  }
  let time = "";
  if (includeTime) {
    time = " " + cHour + ":" + cMinute + ":" + cSecond;
  }
  return cYear + "-" + cMonth + "-" + cDate + time;
}

export function convertStringToDate(dateString) {
  if (dateString === undefined || dateString === "") {
    return false;
  }
  if (dateString.length === 8) {
    return new Date(
      dateString.substring(0, 4) +
        "-" +
        dateString.substring(4, 6) +
        "-" +
        dateString.substring(6, 8)
    );
  }
  return false;
}

export function sortAlphaNum(a, b) {
  // Regular expression to separate the digit string from the non-digit strings.
  const reParts = /\d+|\D+/g;

  // Regular expression to test if the string has a digit.
  const reDigit = /\d/;

  // Get rid of casing issues.
  a = a.name.toLowerCase();
  b = b.name.toLowerCase();

  // Separates the strings into substrings that have only digits and those
  // that have no digits.
  const aParts = a.match(reParts);
  const bParts = b.match(reParts);

  // Used to determine if aPart and bPart are digits.
  let isDigitPart = reDigit.test(aParts[0]);

  // If `a` and `b` are strings with substring parts that match...
  if (aParts && bParts && isDigitPart === reDigit.test(bParts[0])) {
    // Loop through each substring part to compare the overall strings.
    const len = Math.min(aParts.length, bParts.length);
    for (let i = 0; i < len; i += 1) {
      let aPart = aParts[i];
      let bPart = bParts[i];

      // If comparing digits, convert them to numbers (assuming base 10).
      if (isDigitPart) {
        aPart = parseInt(aPart, 10);
        bPart = parseInt(bPart, 10);
      }

      // If the substrings aren't equal, return either -1 or 1.
      if (aPart !== bPart) {
        return aPart < bPart ? -1 : 1;
      }

      // Toggle the value of isDigitPart since the parts will alternate.
      isDigitPart = !isDigitPart;
    }
  }

  // Use normal comparison.
  return (a >= b) - (a <= b);
}

// Sorting functionality
export function sortByName(a, b) {
  return !b.isFile - !a.isFile || sortAlphaNum(a, b);
}

export function sortBySize(a, b) {
  return a.size - b.size;
}

export function sortByDateModified(a, b) {
  return a.lmdt - b.lmdt;
}

export function sortByExtension(a, b) {
  return a.extension.toString().localeCompare(b.extension);
}

export function sortByFirstTag(a, b) {
  if ((!a.tags && !b.tags) || (a.tags.length < 1 && b.tags.length < 1)) {
    return 0;
  }
  if (!a.tags || a.tags.length < 1) {
    return -1;
  }
  if (!b.tags || b.tags.length < 1) {
    return 1;
  }
  return a.tags[0].title.localeCompare(b.tags[0].title);
}

export function shuffleArray(array) {
  // Durstenfeld shuffle
  for (let i = array.length - 1; i > 0; i = -1) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

export function sortByCriteria(data, criteria, order) {
  switch (criteria) {
    case "byName":
      if (order) {
        return data.sort(sortByName);
      }
      return data.sort((a, b) => -1 * sortByName(a, b));
    case "byFileSize":
      if (order) {
        return data.sort(sortBySize);
      }
      return data.sort((a, b) => -1 * sortBySize(a, b));
    case "byDateModified":
      if (order) {
        return data.sort(sortByDateModified);
      }
      return data.sort((a, b) => -1 * sortByDateModified(a, b));
    case "byExtension":
      if (order) {
        return data.sort(sortByExtension);
      }
      return data.sort((a, b) => -1 * sortByExtension(a, b));
    case "byFirstTag":
      if (order) {
        return data.sort(sortByFirstTag);
      }
      return data.sort((a, b) => -1 * sortByFirstTag(a, b));
    case "random":
      return shuffleArray(data);
    default:
      return data.sort(sortByName);
  }
}

/**
 * @description Check if value is of type 'object'
 * @param val
 * @returns {boolean}
 */
export const isObj = (val) => typeof val === "object" && !isArr(val) && !isNull(val);

/**
 * @description Check if value is of type 'null'
 * @param val
 * @returns {boolean}
 */
export const isNull = (val) => val === null;

/**
 * @description Check if value is of type 'number'
 * @param val
 * @returns {boolean}
 */
// eslint-disable-next-line no-restricted-globals
export const isNum = (val) => typeof val === "number" && !isNaN(val);

/**
 * @description Check if value is of type 'function'
 * @param val
 * @returns {boolean}
 */
export const isFunc = (val) => typeof val === "function";

/**
 * @description Check if value is of type 'array'
 * @param val
 * @returns {boolean}
 */
export const isArr = (val) => Array.isArray(val);

/**
 * @description Check if value is of type 'string'
 * @param val
 * @returns {boolean}
 */
export const isStr = (val) => typeof val === "string";

/**
 * @description Check if value is of type 'undefined'
 * @param val
 * @returns {boolean}
 */
export const isUndef = (val) => typeof val === "undefined";

/**
 * @description Check if value is of type 'boolean'
 * @param val
 * @returns {boolean}
 */
export const isBool = (val) => typeof val === "boolean";

/**
 * @description Check if object has property
 * @param obj
 * @param prop
 * @returns {boolean}
 */
export const hasProp = (obj, prop) => obj.hasOwnProperty(prop);

/**
 * @description Check if object has method
 * @param obj
 * @param method
 * @returns {boolean}
 */
export const hasMethod = (obj, method) => hasProp(obj, method) && isFunc(obj[method]);

/**
 * @description Check if object has key
 * @param obj
 * @param key
 * @returns {boolean}
 */
export const hasKey = (obj, key) => getKeys(obj).indexOf(key) > -1;

/**
 * @description Get object keys
 * @param obj
 * @returns {Array}
 */
export const getKeys = (obj) => Object.keys(obj);

/**
 * @description Iterate over each key of an object
 * @param obj
 * @param callback
 */
export function eachKey(obj, callback) {
  Object.keys(obj).forEach((key, index) => callback(key, obj[key], index));
}

/**
 * @description Linear iterator for object properties
 * @param obj
 * @param callback
 */
export function eachProp(obj, callback) {
  eachKey(obj, (key, prop, index) => callback(prop, key, index));
}

/**
 * @description Extend
 * @param baseObject
 * @param restObjects
 * @returns {object}
 */
export function extend(baseObject, ...restObjects) {
  const modifiedObject = { ...baseObject };

  // eslint-disable-next-line compat/compat
  restObjects.map((obj) => Object.assign(modifiedObject, obj));
  return modifiedObject;
}

/**
 * @description Iterate recursively
 * @param handler
 * @param complete
 * @param index
 * @returns {*}
 */
export function recurIter(handler, complete, index = 0) {
  handler((canRecur) => {
    if (!canRecur) {
      return complete();
    }
    const nextIndex = index + 1;
    recurIter(handler, complete, nextIndex);
  }, index);
}

/**
 * @description Poll over an interval of time
 * @param handler
 * @param complete
 * @param interval
 */
export function poll(handler, complete, interval) {
  setTimeout(() => {
    handler((canPoll) => {
      if (canPoll) {
        return poll(handler, complete, interval);
      }
      complete();
    });
  }, interval);
}

/**
 * @description Buffer high-frequency events
 * @returns {function(*=, *=, *=)}
 */
export function buffer({ timeout, id }) {
  const timers = {};

  return (callback) => {
    if (!id) {
      timers[id] = "0";
    }
    if (timers[id]) {
      clearTimeout(timers[id]);
    }
    timers[id] = setTimeout(callback, timeout);
  };
}

/**
 * @description Determine type checker
 * @param type
 * @returns {*}
 */
export function determineTypeChecker(type) {
  switch (type) {
    case "number":
      return isNum;
    case "object":
      return isObj;
    case "null":
      return isNull;
    case "function":
      return isFunc;
    case "array":
      return isArr;
    case "string":
      return isStr;
    case "bool":
    case "boolean":
      return isBool;
    case "undefined":
    default:
      return isUndef;
  }
}

/**
 * @description Set strong typed object using object proxies and traps
 * @param config
 * @returns {*}
 */
export function setStrongTypedObject(config) {
  const proxy = {};
  // eslint-disable-next-line no-return-assign
  eachProp(config, (prop, key) => (proxy[key] = prop.value));

  // eslint-disable-next-line compat/compat
  return new Proxy(proxy, {
    get(target, prop) {
      return target[prop];
    },
    set(target, prop, value) {
      const type = config[prop].type;
      const typeChecker = determineTypeChecker(type);

      if (!typeChecker(value)) {
        throw new Error(
          `[Ammo.StrongType] Invalid type. Expected type for field {${prop}} is {${type}}`
        );
      }

      target[prop] = value;
      return true;
    },
  });
}

/**
 * @description Filter object data
 * @param objectData
 * @param requiredKeys
 */
export function filterObjectData(objectData, requiredKeys) {
  const filteredObject = {};
  eachKey(objectData, (key, value) => {
    if (requiredKeys.indexOf(key) === -1) {
      return false;
    }
    filteredObject[key] = value;
  });
  return filteredObject;
}

/**
 * @description Filter array of objects data
 * @param arrayData
 * @param requiredKeys
 */
export function filterArrayOfObjectsData(arrayData, requiredKeys) {
  return arrayData.reduce((accumulator, item) => {
    const filteredObject = filterObjectData(item, requiredKeys);
    accumulator.push(filteredObject);
    return accumulator;
  }, []);
}

/**
 * @description Pluck object data to array
 * @param objectData
 * @param requiredKey
 */
export function pluckObjectDataToArray(objectData, requiredKey) {
  const filteredArray = [];
  eachKey(objectData, (key, value) => {
    if (requiredKey !== key) {
      return false;
    }
    filteredArray.push(value);
  });
  return filteredArray;
}

/**
 * @description Pluck array of objects data to array
 * @param arrayData
 * @param requiredKey
 */
export function pluckArrayOfObjectsDataToArray(arrayData, requiredKey) {
  return arrayData.reduce((accumulator, item) => {
    const filteredArray = pluckObjectDataToArray(item, requiredKey);
    return [...accumulator, ...filteredArray];
  }, []);
}

/**
 * @description Extract nexted prop
 * @param obj
 * @param keysText
 * @returns {*}
 */
export function extractNestedProp(obj, keysText) {
  const keys = keysText.split(".");
  const keysLength = keys.length - 1;
  let keysIndex = 0;
  let isValidKey = true;
  let targetObj = { ...obj };
  let targetProp;
  let nextTarget;

  if (keys.length > 0) {
    while (isValidKey) {
      nextTarget = targetObj[keys[keysIndex]];

      // ... check if final target is reached ...
      if (keysIndex === keysLength) {
        // ... extract target prop
        targetProp = !isUndef(nextTarget) && !isNull(nextTarget) ? nextTarget : undefined;
        break;
      }

      // ... check if next target is not an object ...
      if (!isObj(nextTarget)) {
        // ... cancel sequence
        isValidKey = false;
        break;
      }

      targetObj = nextTarget;
      keysIndex += 1;
    }
  }

  return targetProp;
}

/**
 * @description Sort by
 * @param items
 * @param keysText
 * @param type
 * @param direction
 */
export function sortBy(items, keysText, type = "string", direction = "asc") {
  return items.sort((a, b) => {
    const aVal = extractNestedProp(a, keysText);
    const bVal = extractNestedProp(b, keysText);

    if (isUndef(aVal) || isNull(aVal)) {
      return direction === "asc" ? -1 : 1;
    }

    if (isUndef(bVal) || isNull(bVal)) {
      return direction === "asc" ? 1 : -1;
    }

    if (type === "string" || type === "email") {
      if (aVal.toLowerCase() > bVal.toLowerCase()) {
        return direction === "asc" ? 1 : -1;
      }
      if (aVal.toLowerCase() < bVal.toLowerCase()) {
        return direction === "asc" ? -1 : 1;
      }
      return 0;
    }
    if (type === "number" || type === "integer" || type === "float") {
      if (aVal > bVal) {
        return direction === "asc" ? 1 : -1;
      }
      if (aVal < bVal) {
        return direction === "asc" ? -1 : 1;
      }
      return 0;
    }
    if (type === "date") {
      return direction === "asc"
        ? new Date(aVal) - new Date(bVal)
        : new Date(bVal) - new Date(aVal);
    }
    return true;
  });
}

/**
 * @description Shape
 * @param items
 * @returns {*}
 */
export function shape(items) {
  let shapeItems = [...items];

  return {
    fetch: () => shapeItems,
    filterByUnique(key) {
      shapeItems = filterByUnique(shapeItems, key);
      return this;
    },
    filterByDuplicate(key, length = 2) {
      shapeItems = filterByDuplicate(shapeItems, key, length);
      return this;
    },
    sortBy({ key, type = "string", direction = "asc" }) {
      shapeItems = sortBy(shapeItems, key, type, direction);
      return this;
    },
    reduceTo(key) {
      shapeItems = shapeItems.reduce((accumulator, item) => {
        const prop = extractNestedProp(item, key);
        if (isArr(prop)) {
          return [...accumulator, ...prop];
        }
        if (!isUndef(prop) && !isNull(prop)) {
          return [...accumulator, prop];
        }
        return true;
      }, []);
      return this;
    },
  };
}

/**
 * @description Filter by unique
 * @param items
 * @param key
 * @returns {*}
 */
export const filterByUnique = (items, key) =>
  items.reduce((accumulator, item) => {
    const itemProp = extractNestedProp(item, key);

    const isDuplicate =
      accumulator.filter((filteredItem) => {
        const prop = extractNestedProp(filteredItem, key);
        return prop === itemProp;
      }).length > 0;

    if (isDuplicate) {
      return accumulator;
    }

    const modifiedItem = extend({}, item);
    accumulator.push(modifiedItem);
    return accumulator;
  }, []);

/**
 * @description Filter by duplicate
 * @param items
 * @param key
 * @param duplicateLength
 * @returns {*}
 */
export const filterByDuplicate = (items, key, duplicateLength = 2) =>
  items.filter((item) => {
    const itemProp = extractNestedProp(item, key);
    const duplicatesCount = duplicateLength - 1;

    return (
      items.filter((innerItem) => {
        const prop = extractNestedProp(innerItem, key);
        return prop === itemProp;
      }).length > duplicatesCount
    );
  });

export function getDateMonth(date) {
  const currentDate = new Date(date).getDate();
  const months = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = new Date(date).getMonth();

  return currentDate + " " + months[month];
}

// parse “YYYYmmdd” to 'Fri Jul 15 2016 00:00:00 GMT+0300 (FLE Summer Time)'
export function parseFullDate(date) {
  // validate year as 4 digits, month as 01-12, and day as 01-31
  date = date.match(/^(\d{4})(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])$/);
  if (date) {
    // make a date
    date[0] = new Date(+date[1], +date[2] - 1, +date[3]);
    // check if month stayed the same (ie that day number is valid)
    if (date[0].getMonth() === +date[2] - 1) {
      return date[0];
    }
  }
}

// return array of [years, month]
// export function parseToDate(date) {
//   const dateMonth = convertToDate(date);
//   let d;
//   if (dateMonth) {
//     d = dateMonth;
//   } else if (dateMonth.length === 5) {
//     const dateString = dateMonth.split('-');
//     d = new Date(dateString[0], dateString[1]);
//   }
//   return d;
// }

// Format Sun May 11, 2014 to 2014-05
export function formatDateMonth(date) {
  const d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  const year = d.getFullYear();

  if (month.length < 2) {
    month = "0" + month;
  }
  return [year, month].join("-");
}

// Format Sun May 11, 2014 to 11/05/2014
export function formatDate(date, isHours = false) {
  const d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  const year = d.getFullYear();
  const h = d.getHours();
  const m = d.getMinutes();
  const s = d.getSeconds();

  if (month.length < 2) {
    month = "0" + month;
  }
  if (day.length < 2) {
    day = "0" + day;
  }

  if (isHours) {
    // return [day, month, year, h + ':' + m + ':' + s].join('/');
    return day + "/" + month + "/" + year + h + ":" + m + ":" + s;
  }

  return [day, month, year].join("/");
}

// Format Sun May 11, 2014 to 11/05/2014
export function formatDateByDay(date, isHours = false) {
  const d = new Date(date);
  let month = "" + (d.getMonth() + 1);
  let day = "" + d.getDate();
  const year = d.getFullYear();
  const h = d.getHours();
  const m = d.getMinutes();
  const s = d.getSeconds();

  if (month.length < 2) {
    month = "0" + month;
  }
  if (day.length < 2) {
    day = "0" + day;
  }

  if (isHours) {
    return [day, month, year, h + ":" + m + ":" + s].join("/");
  }

  return [day, month, year].join("/");
}

export function formatDate1() {
  // ((date.getMonth() > 8) ?
  // (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ?
  // date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
}

export function formatToHHMMSS() {
  const d = new Date();
  const hours = d.getHours();
  const minutes = d.getMinutes();
  const seconds = d.getSeconds();
  return hours + ":" + minutes + ":" + seconds;
}

/* Get the documentElement (<html>) to display the page in fullscreen */
const elem = document.documentElement;

/* View in fullscreen */
export function openFullscreen() {
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.mozRequestFullScreen) {
    /* Firefox */
    elem.mozRequestFullScreen();
  } else if (elem.webkitRequestFullscreen) {
    /* Chrome, Safari and Opera */
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) {
    /* IE/Edge */
    elem.msRequestFullscreen();
  }
}

/* Close fullscreen */
export function closeFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    /* Firefox */
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    /* Chrome, Safari and Opera */
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    /* IE/Edge */
    document.msExitFullscreen();
  }
}

//
// export function debounce(a, b, c) {
//   let d; let e;
//   return () => {
//     function h() {
//       d = null;
//       c || (e = a.apply(f, g));
//     }
//
//     const g = arguments;
//     return clearTimeout(d), d = setTimeout(h, b), c && !d && (e = a.apply(this, g)), e;
//   };
// }

export function slugify(string) {
  const a = "àáäâãåèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;";
  const b = "aaaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------";
  const p = new RegExp(a.split("").join("|"), "g");
  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters in a with b
    .replace(/&/g, "-and-") // Replace & with ‘and’
    .replace(/[^\w-]+/g, "") // Remove all non-word characters such as spaces or tabs
    .replace(/--+/g, "-") // Replace multiple — with single -
    .replace(/^-+/, "") // Trim — from start of text
    .replace(/-+$/, ""); // Trim — from end of text
}

export function urlSlug(title, fingerprint) {
  return `${slugify(title)}-${fingerprint}`;
}

export function validURL(str) {
  const pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(str);
}

export const formatNumber = (number) => {
  // eslint-disable-next-line compat/compat
  return new Intl.NumberFormat("de-DE").format(number);
};

export function convertToCSV(objArray) {
  const array = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
  let str = "";

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < array.length; i++) {
    let line = "";
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const index in array[i]) {
      if (line !== "") line += ",";

      line += array[i][index];
    }

    str += line + "\r\n";
  }

  return str;
}

export function exportCSVFile(headers, items, fileTitle, ext) {
  if (headers) {
    items.unshift(headers);
  }

  // Convert Object to JSON
  const jsonObject = JSON.stringify(items);
  const csv = convertToCSV(jsonObject);
  const exportedFilename = fileTitle + "." + ext || "export.csv";

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  if (navigator.msSaveBlob) {
    // IE 10+
    navigator.msSaveBlob(blob, exportedFilename);
  } else {
    const link = document.createElement("a");
    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", exportedFilename);
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}

// function base64ToArrayBuffer(data) {
//   const binaryString = window.atob(data);
//   const binaryLen = binaryString.length;
//   const bytes = new Uint8Array(binaryLen);
//   for (const i = 0; i < binaryLen; i++) {
//     const ascii = binaryString.charCodeAt(i);
//     bytes[i] = ascii;
//   }
//   return bytes;
// }

export function replaceAll(str, finder, replace, regEx) {
  const escapedFind = finder.replace(regEx);
  return str.replace(new RegExp(escapedFind, "g"), replace);
}

export function formatFileSize(fileSizeInBytes) {
  let kilobyteThreshold = 1024;
  let megabyteThreshold = kilobyteThreshold * 1024;

  if (fileSizeInBytes < kilobyteThreshold) {
    return fileSizeInBytes + " B";
  } else if (fileSizeInBytes < megabyteThreshold) {
    return (fileSizeInBytes / kilobyteThreshold).toFixed(2) + " KB";
  } else {
    return (fileSizeInBytes / megabyteThreshold).toFixed(2) + " MB";
  }
}
